import { Button, Classes, FormGroup } from "@blueprintjs/core";
import styled from "styled-components";

import ArrayItemToolbar from "common/form/common/ArrayItemToolbar";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import IOption from "common/models/IOption";
import React from "react";
import ConditionField from "../ConditionField";
import { ConditionTypeRegistry, ConnectedConditionPreview } from "../ConditionTypeRegistry";
import { ICondition, IConditionType } from "../IConditionType";


interface IContainerCondition {
	operator: "AND" | "OR";
	conditions: ICondition[];
}

const operators: Array<IOption<"AND" | "OR">> = [
	{value: "AND", label: "AND"},
	{value: "OR", label: "OR"}
];

const StyledDivider = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	margin: 8px 0;

	&::before,
	&::after {
		content: "";
		display: block;
		flex-grow: 1;
		height: 2px;
		background-color: rgba(0,0,0,0.2);
		margin: 0 3px;
	}
`;

const ContainerCondition: IConditionType<IContainerCondition> = {
	type: "container",
	label: "Container",
	icon: "list",
	evaluate: (value, state) => {
		if (!value.conditions || value.conditions.length < 1) {
			return true;
		}

		switch(value.operator) {
			case "AND":
				for (const condition of value.conditions) {
					if (!ConditionTypeRegistry.evaluate(condition, state)) {
						return false;
					}
				}
				return true;
			case "OR":
				for (const condition of value.conditions) {
					if (ConditionTypeRegistry.evaluate(condition, state)) {
						return true;
					}
				}
				return false;
			default:
				return false;
		}
	},
	renderField: (value, onChange, options = {} as any, depth = 0) => {

		const { types } = options;

		return (
			<div>
				<FormGroup label="Operator">
					<ButtonSelect
						options={operators}
						onChange={(operator) => onChange({...value, operator})}
						value={value.operator}
					/>
				</FormGroup>
				<FormGroup style={{border: '1px solid rgba(0,0,0,0.2)', padding: '15px'}}>
					{
						(value.conditions || []).map((cc, ci, arr) => [
							ci > 0 && (
								<StyledDivider className={Classes.TEXT_MUTED}>
									{value.operator}
								</StyledDivider>
							),
							<ConditionField
								key={cc.uuid}
								depth={depth + 1}
								options={options}
								uiSchema={undefined}
								idSchema={undefined}
								formData={cc}
								onChange={(condition) => onChange({
									...value,
									conditions: value.conditions.map((c, i) => i === ci ? condition : c)
								})}
							>
								<ArrayItemToolbar
									itemIndex={ci}
									arr={arr}
									onChange={(conditions) => onChange({...value, conditions})}
								/>
							</ConditionField>
						])
					}
					<div style={{textAlign: 'center'}}>
						<Button
							small={true}
							icon="small-plus"
							text="Add"
							onClick={() => onChange({
								...value,
								conditions: [...value.conditions || [], ConditionTypeRegistry.create(types[0].type)]
							})}
						/>
					</div>
				</FormGroup>
			</div>
		);
	},
	renderPreview: (value) => {

		return (
			<div style={{padding: '15px'}}>
				{
					value.conditions && value.conditions.map((condition, i) => {

						const ct = ConditionTypeRegistry.get(condition.type);

						return (
							<React.Fragment key={condition.uuid}>
								{
									i > 0 && (
										<StyledDivider className={Classes.TEXT_MUTED}>
											{value.operator}
										</StyledDivider>
									)
								}
								<ConnectedConditionPreview condition={condition} />
							</React.Fragment>
						);
					})
				}
			</div>
		);
	},
	getInitialValue: () => {
		return {
			operator: 'AND',
			conditions: []
		};
	}
};

export default ConditionTypeRegistry.register(ContainerCondition);



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/conditionTypes/ContainerCondition.reg.tsx